import { Rating } from "@material-ui/lab";
import React from "react";
import {
  getMovers,
  time_convert,
} from "../../../../../../ui_libs/Functions/functions";

function FeedbackGiven(props) {
  const { requestData, fetchRequestDetails } = props;
  const { truck_array, request } = requestData;
  const { id, final_amount, request_type, total_discount, s_time } =
    requestData.request;
  const { first_name, last_name } = requestData.get_foreman_of_company;

  return (
    <>
      <div className="rounded-box">
        <div className="heading-wrapper black-bg text-center">
          <h6 className="text-white">Request #{id}</h6>
        </div>
        <div className="request-left-box p-3 p-sm-4">
          <div className="row">
            <div className="col-8">
              <div className="request-staus small-font-size">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="8" cy="8" r="8" fill="#C4314B"></circle>
                </svg>{" "}
                Feedback Done
              </div>
            </div>
            <div className="col-4 text-right">
              {request.sale_man_request_status && (
                <span className="custom-chip">Against You</span>
              )}
            </div>
          </div>
          <div className="bid-form-wrapper pt-3">
            <div className="row small-font-size">
              <div className="col-6 text-left dark-grey-color">Start time:</div>
              <div className="col-6 text-right black-color">
                {/* {`${time_convert(s_time.slice(0,5))} to ${time_convert(s_time.slice(8,13))}`} */}
                {s_time &&
                  s_time !== "8AM - 12PM Morning" &&
                  s_time !== "12PM - 5PM Evening" &&
                  s_time !== "Entire day" &&
                  `${time_convert(
                    s_time.split("-")[0].trim()
                  )} to ${time_convert(s_time.split("-")[1].trim())}`}
                {s_time &&
                  (s_time == "8AM - 12PM Morning" ||
                    s_time == "12PM - 5PM Evening" ||
                    s_time == "Entire day") &&
                  `${s_time}`}
              </div>
            </div>
            <div className="row small-font-size pt-3">
              <div className="col-6 text-left dark-grey-color">Movers:</div>
              <div className="col-6 text-right black-color">
                {getMovers(requestData)}
              </div>
            </div>
            <div className="row small-font-size pt-3">
              <div className="col-6 text-left dark-grey-color">Truck Name:</div>
              <div className="col-6 text-right light-red-color">
                {truck_array.map((truck, i) => {
                  return (
                    truck.name + (i === truck_array.length - 1 ? "" : ", ")
                  );
                })}
              </div>
            </div>
            <div className="row small-font-size pt-3">
              <div className="col-6 text-left dark-grey-color">
                Foreman name:
              </div>
              <div className="col-6 text-right light-red-color">
                {first_name + " " + last_name}
              </div>
            </div>
            {request_type && total_discount && total_discount !== "0" && (
              <>
                <div className="row small-font-size pt-3">
                  <div className="col-6 text-left dark-grey-color">Price:</div>
                  <div className="col-6 text-right black-color">
                    ${Number(final_amount) + Number(total_discount)}
                  </div>
                </div>
                <div className="row small-font-size pt-3">
                  <div className="col-6 text-left dark-grey-color">
                    Discount:
                  </div>
                  <div className="col-6 text-right light-red-color">
                    ${total_discount}
                  </div>
                </div>
              </>
            )}
            <div className="row small-font-size pt-3">
              <div className="col-6 text-left dark-grey-color">
                Final Price:
              </div>
              <div className="col-6 text-right black-color">
                ${final_amount}
              </div>
            </div>

            {props.requestData?.get_feedback && (
              <div className="row small-font-size pt-3">
                <div className="col-6 text-left dark-grey-color">Rating:</div>
                <div className="col-6 text-right black-color">
                  <Rating
                    style={{ verticalAlign: "bottom" }}
                    name="read-only"
                    precision={0.1}
                    value={props.requestData?.get_feedback?.customer_rating}
                    size="large"
                    readOnly
                  />
                </div>
              </div>
            )}
            {props.requestData?.get_feedback && (
              <div className="row pt-1">
                <div className="col-12 text-left dark-grey-color">
                  Feedback:
                </div>
                <div className="col-12 extra-small-font-size pt-1">
                  {props.requestData?.get_feedback?.customer_comment}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default FeedbackGiven;
